import React from "react"

import styles from "./layout-service.module.css"

export default function LayoutService({ children }) {
  return <div className={styles.layoutService}>{children}</div>
}
